import {Order} from './Order';

export class Cart {
  private static instance: Cart;
  private _order: Order;
  get order(): Order {
    return this._order;
  }
  set order(value: Order) {
    this._order = value;
  }
  static getInstance() {
    if (this.instance == null) {
      this.instance = new Cart();
    }
    return this.instance;
  }
  private constructor() {
    this._order = new Order();
  }

  packOrder = (): Object => {
    let timeIndexes = [];
    let extrasIndexes = [];

    for (let item of this.order.getSelectedTime()) {
      timeIndexes.push(item['index']);
    }
    

    if(this.order.getNumberOfPersons()) {
      extrasIndexes.push(this.order.getNumberOfPersons()['index']);
    }

    // extrasIndexes.push(this.order.getBathFilling());

    if(this.order.getLightSource()) {
      extrasIndexes.push(this.order.getLightSource()['index']);
    }
    
    if(this.order.getExtraDressingRoom()) {
      extrasIndexes.push(this.order.getExtraDressingRoom()['index']);
    }

    // for (let item in this.order.getDress()) {
    //   extrasIndexes.push(+item);
    // }

    // console.log(extrasIndexes);


    let packedObject = {
      userName: this.order.userFullName,
      email: this.order.userEmail,
      phone: this.order.userPhoneNumber,
      paymentMethodId: this.order.paymentMethodId,
      dateDue: this.order.getSelectedDate().format('YYYY-MM-DD'),
      timeDue: timeIndexes.length,
      items: [
        {
          productId: this.order.getSelectedHall()['product_id'],
          intervals: {},
          options: [
            extrasIndexes.filter( (x)=> x !== undefined && x !== null),
          ]
        }
      ]
    };

    packedObject['items'][0]['intervals'][this.order.getSelectedDate().format('L')] = timeIndexes;
    // console.log(packedObject);
    return packedObject;
  }


}
